export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/ac478f259eebce517c6cc06e4306b00d.svg";